var map = {
	"./breadcrumbs": [
		42501,
		2501
	],
	"./breadcrumbs.ts": [
		42501,
		2501
	],
	"./student": [
		74645,
		4645
	],
	"./student/": [
		74645,
		4645
	],
	"./student/components": [
		73848,
		3848
	],
	"./student/components/": [
		73848,
		3848
	],
	"./student/components/homework-card": [
		75081,
		5081
	],
	"./student/components/homework-card.tsx": [
		75081,
		5081
	],
	"./student/components/index": [
		73848,
		3848
	],
	"./student/components/index.ts": [
		73848,
		3848
	],
	"./student/index": [
		74645,
		4645
	],
	"./student/index.ts": [
		74645,
		4645
	],
	"./student/student": [
		33339,
		3339
	],
	"./student/student.tsx": [
		33339,
		3339
	],
	"./teacher": [
		57404,
		7404
	],
	"./teacher/": [
		57404,
		7404
	],
	"./teacher/components": [
		46802,
		6802
	],
	"./teacher/components/": [
		46802,
		6802
	],
	"./teacher/components/homework-card": [
		50042,
		42
	],
	"./teacher/components/homework-card.tsx": [
		50042,
		42
	],
	"./teacher/components/index": [
		46802,
		6802
	],
	"./teacher/components/index.ts": [
		46802,
		6802
	],
	"./teacher/index": [
		57404,
		7404
	],
	"./teacher/index.tsx": [
		57404,
		7404
	],
	"./teacher/teacher": [
		14882,
		4882
	],
	"./teacher/teacher.tsx": [
		14882,
		4882
	],
	"./utils": [
		4095,
		4095
	],
	"./utils.ts": [
		4095,
		4095
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73511;
module.exports = webpackAsyncContext;